"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectStack = void 0;
var _react = _interopRequireWildcard(require("react"));
var _select = require("@cbhq/cds-common/tokens/select");
var _eventHandlers = require("../utils/eventHandlers");
var _HelperText = require("./HelperText");
var _InputLabel = require("./InputLabel");
var _InputStack = require("./InputStack");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SelectStack = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function SelectStack({
  children,
  compact,
  label,
  disabled,
  helperText,
  variant,
  focused,
  accessibilityLabelId,
  accessibilityDescriptionId,
  helperTextErrorIconAccessibilityLabel = 'error'
}, ref) {
  return /*#__PURE__*/_react.default.createElement(_InputStack.InputStack, {
    ref: ref,
    disabled: disabled,
    focused: focused,
    helperTextNode: Boolean(helperText) && (typeof helperText === 'string' ?
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      onClick: _eventHandlers.handlePreventPropagation
    }, /*#__PURE__*/_react.default.createElement(_HelperText.HelperText, {
      color: variant !== null && variant !== void 0 ? variant : 'foregroundMuted',
      errorIconAccessibilityLabel: helperTextErrorIconAccessibilityLabel,
      errorIconTestID: "select-error-icon",
      id: accessibilityDescriptionId,
      overflow: "truncate"
    }, helperText)) : helperText),
    inputNode: children,
    labelNode: !compact && !!label &&
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      onClick: _eventHandlers.handlePreventPropagation
    }, /*#__PURE__*/_react.default.createElement(_InputLabel.InputLabel, {
      color: _select.labelTextColor,
      id: accessibilityLabelId,
      overflow: "truncate"
    }, label)),
    variant: variant,
    width: "100%"
  });
}));
exports.SelectStack = SelectStack;